var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[(_vm.opened)?_c('div',{staticClass:"ds-dropdown",style:(Object.assign({}, _vm.positionStyle,
      {transition: ("opacity " + _vm.transitionTime + "ms ease")})),on:{"mouseout":_vm.onMouseout}},[_c('div',{staticClass:"ds-focus-trap",attrs:{"tabindex":"0"}}),_c('div',{ref:"dropdownContent",staticClass:"ds-dropdown-content",class:[{ 'ds-border-content': _vm.borderColor }],style:({
        transition: ("transform " + _vm.transitionTime + "ms ease"),
        borderColor: _vm.borderColor,
        minWidth:
          _vm.targetElement && _vm.fullWidth
            ? _vm.targetElement.getBoundingClientRect().width + 'px'
            : 'auto'
      })},[_vm._t("default")],2),_c('div',{staticClass:"ds-focus-trap",attrs:{"tabindex":"0"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }